import { createContext } from 'react';
import type { ResolvedGuide } from './lib/guide';
import type { FaqGroup, HelpContext, HelpFaq, HelpFaqCta, HelpMessage } from './lib/types';

export interface HelpStore {
  isOpen: boolean;
  activeContext: HelpContext;
  /** Shown in the breadcrumb; null at page level. */
  parentContext: HelpContext | null;
  /** Params of the route the current location matched (fills `:id` in CTA targets). */
  routeParams: Record<string, string>;
  faqGroups: FaqGroup[];
  /** The PageGuideCard copy the chat pane opens onto for the active context. */
  guide: ResolvedGuide;
  messages: HelpMessage[];
  pending: boolean;
  selectedFaqId: string | null;
  draft: string;
  contactEmail: string;
  openHelp: (contextKey?: string) => void;
  closeHelp: () => void;
  setContext: (contextKey: string) => void;
  askFaq: (faqId: string) => void;
  sendMessage: (text: string) => void;
  setDraft: (text: string) => void;
  runCta: (cta: HelpFaqCta) => void;
  findFaq: (faqId: string) => HelpFaq | undefined;
}

export const HelpStoreContext = createContext<HelpStore | undefined>(undefined);
